<template>
  <v-card
    tile
    outlined
    class="mb-3"
    :ripple="false"
    elevation="0"
    @click="showFabricPickerOverlay = true"
  >
    <v-list-item
      class="pa-2 text-left"
      style="min-height: auto"
      three-line
    >
      <v-list-item-avatar
        tile
        class="ma-0 mr-6"
        size="96"
      >
        <v-img :src="fabric.rendered_image" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title
          :title="fabric.name"
          class="text-body-1 primary--text"
        >
          {{ fabric.name }} curtain {{ accessory }}
        </v-list-item-title>
        <v-list-item-title
          v-if="hasDiscountPrice"
          :title="price"
          class="text-h4 text-sm-h2 font-weight-bold black--text"
        >
          <span class="underscoredText">$ {{ originPrice * quantity }}</span>
          <span
            :class="$vuetify.breakpoint.width <= 500 ? 'padding-left: 10px' : ''"
            style="color: red"
          >
            $ {{ discountPrice * quantity }}
          </span>
        </v-list-item-title>
        <v-list-item-title
          v-else
          :title="price"
          class="text-h4 text-sm-h2 font-weight-bold black--text"
        >
          {{ price * quantity }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { TRACK_RAIL } from '@/constants.js'

export default {
  name: 'FabricPickerCard',
  data: () => ({
    showFabricPickerOverlay: false
  }),
  computed: {
    ...mapGetters({
      curtainPrice: 'order/getCurtainPrice',
      railRodPrice: 'order/getRailRodPrice',
      railRodType: 'order/getRailRodType',
      withRailRod: 'order/getWithRailRod',
      hasDiscountPrice: 'order/hasDiscountPrice',
      discountRailRodPrice:'order/getRailRodDiscountPrice',
      discountCurtainPrice:'order/getCurtainDiscountPrice',
      originRailRodPrice:'order/getRailRodOriginPrice',
      originCurtainPrice:'order/getCurtainOriginPrice'
    }),

    fabric() {
      // note that this component can be used for main fabrics only
      return this.$store.getters['order/getFabric'] || {}
    },
    quantity() {
      return this.$store.getters['order/getCurtainQuantity'] || 1
    },
    price() {
      const totalPrice = this.curtainPrice + this.railRodPrice
      return totalPrice.toFixed(2)
    },
    discountPrice() {
      const totalDiscountPrice = this.discountCurtainPrice + this.discountRailRodPrice
      return  totalDiscountPrice ? totalDiscountPrice.toFixed(2) : 0
    },
    originPrice() {
      const originPrice = this.originCurtainPrice + this.originRailRodPrice
      return originPrice.toFixed(2)
    },
    accessory() {
      if (this.withRailRod) {
        return this.railRodType === TRACK_RAIL ? 'with Track' : 'with Rod'
      } else {
        return ''
      }
    },
    subTitle() {
      // fabric composition values
      const fabricProperties = [
        'ac',
        'co',
        'div',
        'li',
        'lrx',
        'ma',
        'pa',
        'pe',
        'trcs',
        'se',
        'vi',
        'wol',
        'shrinkage_value'
      ]
      // only get the fabric properties that exist on the fabric
      const filteredFabricProperties = fabricProperties.filter(
        (property) => this.fabric[property]
      )
      // format the existing properties
      const formattedProperties = filteredFabricProperties.map((property) => {
        const value = this.fabric[property]
        if (property === 'shrinkage_value') {
          // fabric shrinkage
          return this.$i18n.t(
            'components.fabricPickerCard.formattedFabricShrinkage',
            { value }
          )
        } else {
          // fabric composition
          const label = property.toUpperCase()
          return this.$i18n.t(
            'components.fabricPickerCard.formattedFabricComposition',
            { label, value }
          )
        }
      })
      // join the properties
      return formattedProperties.join(' | ')
    }
  }
}
</script>
<style lang="scss">
  .underscoredText {
    text-decoration: line-through;
    text-decoration-color: red
  }
</style>
